import React, { useEffect } from "react";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/playfair-display/900.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import ZahaNavigation from "@/components/ZahaNavigation";
import ZahaHero from "@/components/ZahaHero";
import ZahaEngineering from "@/components/ZahaEngineering";
import ZahaMusic from "@/components/ZahaMusic";
import ZahaContact from "@/components/ZahaContact";
import { Toaster } from "@/components/ui/toaster";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <ZahaNavigation />
      <main>
        <ZahaHero />
        <ZahaEngineering />
        <ZahaMusic />
        <ZahaContact />
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;